import { combineReducers } from 'redux';
import MediaReducer from 'store/reducers/MediaReducer';
import AppReducer from 'store/reducers/AppReducer';
import AuthReducer from 'store/reducers/AuthReducer';
import ConfigReducer from 'store/reducers/ConfigReducer';
import CartReducer from 'store/reducers/CartReducer';
import ProfileReducer from 'store/reducers/ProfileReducer';

export default combineReducers({
    media: MediaReducer,
    app: AppReducer,
    auth: AuthReducer,
    cart: CartReducer,
    config: ConfigReducer,
    profile: ProfileReducer
});